import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-7" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import TabComponent from '@/components/TabComponent.vue';
import FormSection from './FormSection.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreatePage',
  setup(__props) {

const tabs: { name: string, count: number, href?: string, allowed: boolean }[] = [
    {
        name: 'Information',
        count: 0,
        allowed: true
    },
    {
        name: 'Permissions',
        count: 0,
        href: '/accounts/roles/permission',
        allowed: true
    },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "Create Role",
    "show-back": "",
    backUrl: "/accounts/roles"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, { tabs: tabs })
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, null, {
          default: _withCtx(() => [
            _createVNode(ButtonComponent, { onClick: _ctx.submit }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Save Changes ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})